import { formatDate } from '@/utils';

/**
 * Formats a date object to display format (e.g., "Oct 11, 2023")
 */
export const formatScoreHistoryDate = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return formatDate(dateObj, 'fullDate');
};

/**
 * Formats a time to display format (e.g., "11:35am")
 */
export const formatScoreHistoryTime = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return formatDate(dateObj, 'time');
};

